var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27534",
    "data-name": "Group 27534",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.943,
    height: 37.771,
    viewBox: "0 0 151.943 37.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13371",
    "data-name": "Rectangle 13371",
    width: 151.943,
    height: 37.771,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17710",
    "data-name": "Group 17710",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38623",
    "data-name": "Path 38623",
    d: "M27.252,31.077c.191.191.191.478.191.956v4.59c0,.669-.382,1.052-1.147,1.052H1.052a1.086,1.086,0,0,1-.765-.287A1.086,1.086,0,0,1,0,36.623V1.243C0,.478.382,0,1.147,0h24.67a1.007,1.007,0,0,1,.956.382,1.615,1.615,0,0,1,.287.956V5.833a1.086,1.086,0,0,1-.287.765,1.461,1.461,0,0,1-.956.382H7.459v7.745H21.515a1.286,1.286,0,0,1,.861.191,1.169,1.169,0,0,1,.287.861v4.59a1.086,1.086,0,0,1-.287.765,1.212,1.212,0,0,1-.861.382H7.459v9.18H26.3a1.8,1.8,0,0,1,.956.382",
    fill: "#06233d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38624",
    "data-name": "Path 38624",
    d: "M69.178,23.914a10.41,10.41,0,0,0-.956-2.391,10.858,10.858,0,0,0-1.434-2.2,16.3,16.3,0,0,0-1.817-1.817,9.447,9.447,0,0,0,2.008-3.06,10.064,10.064,0,0,0,.669-3.825,9.591,9.591,0,0,0-.861-4.112,11.581,11.581,0,0,0-2.295-3.347A9.249,9.249,0,0,0,61.05.965,10.292,10.292,0,0,0,56.843.2H41.734A1.323,1.323,0,0,0,40.3,1.634V36.441a1.007,1.007,0,0,0,.382.956,1.74,1.74,0,0,0,1.052.382H58.564a9.45,9.45,0,0,0,4.3-.956A11.311,11.311,0,0,0,66.4,34.337,11.45,11.45,0,0,0,69.56,26.5a8.054,8.054,0,0,0-.382-2.582M47.95,6.7H55.6a4.912,4.912,0,0,1,3.251,1.052,3.7,3.7,0,0,1,1.243,2.964,5.567,5.567,0,0,1-.287,1.817,3.783,3.783,0,0,1-.956,1.434,3.783,3.783,0,0,1-1.434.956,5.591,5.591,0,0,1-1.817.382H48.045c-.1,0-.1-8.606-.1-8.606M61.432,28.217A5.1,5.1,0,0,1,58.851,30.8a3.881,3.881,0,0,1-1.817.382h-9.18V21.237h9.18a3.88,3.88,0,0,1,1.817.382,5.833,5.833,0,0,1,1.53,1.147,9.474,9.474,0,0,1,1.052,1.626,4.144,4.144,0,0,1,.382,1.817,4.435,4.435,0,0,1-.382,2.008",
    transform: "translate(-1.764 -0.009)",
    fill: "#06233d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38625",
    "data-name": "Path 38625",
    d: "M87.972.387A1.542,1.542,0,0,0,87.111.1H81.947a1.169,1.169,0,0,0-.861.287,1.086,1.086,0,0,0-.287.765v35.38a1.014,1.014,0,0,0,1.147,1.147h5.164c.861,0,1.243-.382,1.243-1.147V1.152a.7.7,0,0,0-.382-.765",
    transform: "translate(-3.537 -0.004)",
    fill: "#06233d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38626",
    "data-name": "Path 38626",
    d: "M138.279,30.317a4.067,4.067,0,0,0-1.052.191l-13.2-27.826A4.2,4.2,0,0,0,120.3.1a4.093,4.093,0,0,0-3.729,2.582L103.281,30.508a3.438,3.438,0,0,0-1.052-.191,3.682,3.682,0,1,0,2.295.765l13.2-27.826a2.743,2.743,0,0,1,5.164,0l13.2,27.826a3.737,3.737,0,1,0,6.024,2.964,3.88,3.88,0,0,0-3.825-3.729m-36.05,5.929a2.295,2.295,0,1,1,2.295-2.295,2.265,2.265,0,0,1-2.295,2.295m36.05,0a2.295,2.295,0,1,1,2.295-2.295,2.265,2.265,0,0,1-2.295,2.295",
    transform: "translate(-4.312 -0.004)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38627",
    "data-name": "Path 38627",
    d: "M155.5,30.412V7.463A3.71,3.71,0,0,0,154.829.1,3.674,3.674,0,0,0,151.1,3.829a3.7,3.7,0,0,0,3.06,3.634V30.412a3.713,3.713,0,1,0,4.4,3.634,3.792,3.792,0,0,0-3.06-3.634M152.534,3.829a2.295,2.295,0,1,1,4.59,0,2.327,2.327,0,0,1-2.295,2.295,2.394,2.394,0,0,1-2.295-2.295m2.295,32.416a2.295,2.295,0,1,1,2.295-2.295,2.265,2.265,0,0,1-2.295,2.295",
    transform: "translate(-6.615 -0.004)",
    fill: "#06233d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.106753ed24e43ac3590a8627119b1d24.svg";
export { ForwardRef as ReactComponent };